import { EntityStore } from 'shared/stores/EntityStore';

class JobPositionChangelogStore extends EntityStore {
	entityPluralEndpoint = 'jobs/changelog';
	constructor() {
		super('job-position-changelog');
	}

	typeOptions = [
		{ text: 'Title', value: 'title' },
		{ text: 'Status', value: 'status' },
		{ text: 'Visibility', value: 'disabled' },
		{ text: 'Priority', value: 'priority' },
		{ text: 'Urgency', value: 'urgency' },
		{ text: 'Summary', value: 'summary' },
		{ text: 'Description', value: 'description' },
		{ text: 'Work Schedule', value: 'workSchedule' },
		{ text: 'Term', value: 'term' },
		{ text: 'Location Type', value: 'locationType' },
		{ text: 'Responsibilities', value: 'responsibilities' },
		{ text: 'Requirements', value: 'requirements' },
		{ text: 'Bonus Points', value: 'bonusPoints' },
		{ text: 'Offers', value: 'offers' },
		{ text: 'Budget', value: 'budget' },
		{ text: 'Client', value: 'clientId' },
		{ text: 'Hiring Manager', value: 'hiringManagerId' },
		{ text: 'Account Manager', value: 'accountManagerId' },
		{ text: 'Role', value: 'roleId' },
		{ text: 'Technologies', value: 'technologies' },
		{ text: 'Timezones', value: 'timezones' },
		{ text: 'Locations', value: 'locations' },
		{ text: 'Owners', value: 'owners' }
	];
}

export const jobPositionChangelogStore = new JobPositionChangelogStore();
